import { render, staticRenderFns } from "./CategoryDisplay.vue?vue&type=template&id=7c4984cc&scoped=true&"
import script from "./CategoryDisplay.vue?vue&type=script&lang=js&"
export * from "./CategoryDisplay.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDisplay.vue?vue&type=style&index=0&id=7c4984cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4984cc",
  null
  
)

export default component.exports